import Backbone from 'backbone';
import AnswersCollection from 'ef/collections/answers_collection';

const Question = Backbone.Model.extend({
  initialize: function (attrs) {
    this.parse(attrs);
  },
  parse: function (json) {
    this.answers = new AnswersCollection(json.answers);
    return json;
  },
});

export default Question;
